import { ComponentProps } from "react";

export default function CartIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.5 7.5V4.5C4.5 2.567 6.51472 1 9 1C11.4853 1 13.5 2.567 13.5 4.5V7.5"
        stroke="currentColor"
      />
      <rect x="0.5" y="5" width="17" height="10.25" stroke="currentColor" />
    </svg>
  );
}
